export default {
  dialogRoot: {
    '& .MuiDialogActions-root button:nth-child(2)': {
      display: 'none'
    }
  }
}